<template>
  <div class="teacher_wrapper w">
    <div
      v-if="componentInfo.config.showTitle"
      class="teacher_title"
    >
      <div class="teacher_title_name">
        <img
          class="mgr10"
          src="@/assets/pc/mini-title3.png"
          alt=""
        >
        <span>{{ componentInfo.config.title }}</span>
      </div>
      <NuxtLink
        to="/tch/list"
        style="display:flex;align-items: center;"
      >
        <div
          v-if="componentInfo.config.showMore"
          class="teacher_title_more pointer"
        >
          <span>更多</span>
          <img
            src="https://huawei-newykt-32.obs.cn-north-4.myhuaweicloud.com/1675680587354451969/b664ce8a19524213aa04cf6c928f69dd.png"
            class="arrows"
          />
        </div>
      </NuxtLink>
    </div>
    <div
      v-if="teacherChunk.length > 0"
      class="banner"
    >
      <div
        class="banner-content"
        @mouseout="mout"
        @mouseover="mover"
      >
        <ul
          class="banner-list"
          style="height: 164px"
        >
          <li
            v-for="(teacherList, index) in teacherChunk"
            :key="index"
            class="item"
            :class="{ on: index === num }"
          >
            <NuxtLink
              v-for="teacher in teacherList"
              :key="teacher.id"
              :to="'/tch/view?id=' + teacher.id"
              class="teacher_item_wrapper"
            >
              <div class="teacher_item">
                <div class="teacher_item_hover">
                  <span :class="{ 'ov-tx-9': teacher.introduce.length > 150 }">{{ teacher.introduce || '暂无简介' }}</span>
                </div>
                <div
                  v-if="teacher.headImg"
                  class="item_image_wrapper item_image"
                >
                  <img :src="teacher.headImg">
                </div>
                <div class="teacher_item_info">
                  <div>
                    <h3>{{ teacher.nickname }}</h3>
                    <p class="teacher_py">{{ teacher.namePinYin }}</p>
                  </div>
                  <div>
                    <div class="info_box">
                      <template v-if="teacher.auths">
                        <div
                          class="item_info"
                          v-for="item in teacher.auths.split(';')"
                          :key="item"
                        >{{ item }}</div>
                      </template>
                    </div>
                    <div class="tag_box">
                      <div class="item_tag">名师</div>
                    </div>
                  </div>
                  <div class="type_image" v-if="teacher.rankName">{{ teacher.rankName }}</div>
                </div>
                <!-- <div class="teacher_name tx-ov">
                  {{ teacher.nickname }}
                </div>
                <div class="teacher_info">
                      <span>课程{{ ' ' + (teacher.courseCount || 0) }}</span>
                       <span class="border" />
                      <span>班级{{ ' ' + (teacher.classroomCount || 0) }}</span>
                    </div>
                <div class="teacher_intro tx-ov-2">
                  <p>{{ teacher.introduce || '暂无简介' }}</p>
                </div> -->
              </div>
            </NuxtLink>
          </li>
        </ul>
        <ul class="page_dots">
          <span
            v-for="(item, index) in teacherChunk"
            :key="index"
            class="dots"
            :class="{ on: index === num }"
            @mouseenter="num = index"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from 'vue'
import { chunk } from 'lodash-es'
export default defineComponent({
  props: {
    componentInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup(props, { emit }) {
    const teacherChunk = computed(() => {
      return chunk(props.componentInfo.data, 3)
    })
    const num = ref(0)
    const interval = ref(null)
    const change = () => {
      interval.value = setInterval(() => {
        if (num.value + 1 >= teacherChunk.value.length) {
          num.value = 0
        } else {
          num.value++
        }
      }, 5000)
    }
    const mout = () => {
      change()
    }
    const mover = () => {
      clearInterval(interval.value)
    }
    return {
      num,
      interval,
      mout,
      mover,
      teacherChunk
    }
  }
})
</script>
<style lang="scss" scoped>
.teacher_wrapper {
  padding: 25px 0px;

  .border {
    background: #becadb;
    display: inline-block;
    height: 10px;
    margin: 0 10px;
    width: 1px;
  }
}

.teacher_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  line-height: 22px;
  color: #333;
}

.teacher_title_name {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 24px;
  line-height: 34px;

  img {
    width: 180px;
  }

  span {
    font-size: 14px;
    color: #333;
    margin-left: 40px;
  }
}

.teacher_title_more {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;

  span {
    margin-right: 6px;
  }

  .arrows {
    width: 16px;
    height: 16px;
    padding-right: 0px;
  }
}

.more_img {
  margin-left: 4px;
}

.teacher_item_info {
  height: 100%;
  width: 65%;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  h3 {
    font-size: 18px;
    line-height: 26px;
    margin: 0;
    padding: 0;
    margin-bottom: 2px;
  }

  .teacher_py {
    font-size: 12px;
    line-height: 14px;
  }
}

.info_box {
  width: 100%;

  .item_info {
    font-size: 12px;
    line-height: 14px;
    color: #999;
    margin-bottom: 4px;
  }
}

.tag_box {
  width: 100%;

  .item_tag {
    display: inline-block;
    padding: 1px 6px;
    line-height: 14px;
    box-sizing: border-box;
    background-color: #f20000;
    font-size: 12px;
    margin-right: 6px;
    border-radius: 4px;
    color: #fff;
  }
}

.type_image {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 124.416px;
  height: 53.76px;
  background: url("https://huawei-newykt-32.obs.cn-north-4.myhuaweicloud.com/1675680587354451969/78436c7f64fe4b24a0d9e41d41a7a86b.png") no-repeat center center;
  background-size: 100% 100%;
  font-size: 14px;
  color: #fff;
  padding: 9px 16px;
  box-sizing: border-box;
}

.teacher_item_wrapper {
  height: 144px;
  width: 33.33%;
  padding: 0px 10px;
  box-sizing: border-box;
  position: relative;
}

.teacher_item {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  background-color: #f5f7fa;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 0px 4px #ccc;

  &:hover {
    .teacher_item_hover {
      display: flex;
      align-items: center;
      justify-content: center;
      top: 0;
      padding: 10px;
    }

    .teacher_item_hover .ov-tx-9 {
      font-weight: 400;
      font-size: 14px;
      line-height: 25px;
      text-overflow: ellipsis;
      display: -webkit-box;
      /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical;
      /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 9;
      /** 显示的行数 **/
      overflow: hidden;
      /** 隐藏超出的内容 */
    }
  }
}

.teacher_item_hover {
  position: absolute;
  left: 0;
  top: 120%;
  width: 100%;
  transition: all 0.3s;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  display: none;
  z-index: 99;
  color: #FFFFFF;
}

.item_image_wrapper {
  width: 116px;
  height: 116px;
  position: relative;
  overflow-y: auto;
}

.item_image {
  width: 32%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;

  img {
    border-radius: 4px;
    overflow: hidden;
  }
}

.teacher_name {
  padding: 0 20px;
  margin-top: 18px;
  font-weight: 500;
  color: #333;
  font-size: 16px;
  line-height: 20px;
}

.teacher_info {
  margin-top: 10px;
  padding: 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.banner {
  position: relative;

  .banner-content {
    margin: 0 auto;
    position: relative;
    // background: #e3e3e3;
  }

  ul {
    position: relative;
  }

  .banner-list {}

  .item {
    display: flex;
    margin-left: -10px;
    margin-right: -10px;
    opacity: 0;
    height: 100%;
    background-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    transition: all 1s;

    &.on {
      opacity: 1;
      z-index: 10;
    }

  }

  .page_dots {
    cursor: pointer;
    margin-top: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px 15px 0;
    border-radius: 13px;
    height: 26px;

    // background: rgba(0, 0, 0, 0.2);
    &.old {
      left: 0;
      right: 0;
      margin-right: 0;
      bottom: 30px;
    }

    .dots {
      display: inline-block;
      width: 8px;
      height: 6px;
      margin: 0 4px;
      background: #BECADB;
      border-radius: 15px;

      &.on {
        width: 14px;
        background: #888;
      }
    }
  }

}

.teacher_intro {
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}</style>
